import type { Plan } from '@base/api';
import { usePlans } from './usePlans';

export const getAgentPlan = (
  plans: Plan[],
  planName: string,
): Plan | undefined => {
  const plan = plans.find((p) => p.name.toLowerCase() === planName);

  if (!plan) return;

  return {
    ...plan,
    price: plan.price / 100,
  };
};

export const useAgentPlan = ({ planName }: { planName: string }) => {
  const {
    data: plans = [],
    isPending: isPlansPending,
    refetch: refetchPlans,
  } = usePlans();

  return {
    data: getAgentPlan(plans, planName),
    isPending: isPlansPending,
    refetch: async () => {
      const result = await refetchPlans();
      return {
        data: getAgentPlan(result.data ?? [], planName),
      };
    },
  };
};
